import { ApiModule, type PaginatedResponseData } from '@common/index';
import type { EducationFormItem, EducationForm } from '../models';

export class EducationFormApi extends ApiModule {
  protected endpoint = '/education-form';

  public async pageEducationForms(params: any) {
    return this.api.post<PaginatedResponseData<EducationFormItem>, any>(
      `${this.endpoint}/page?page=${params.page}&size=${params.itemsPerPage}&sort=${params.sort ?? ''}`,
      {
        ...params
      }
    );
  }

  public loadEducationFormDetails(id: number) {
    return this.api.get<EducationForm>(`${this.endpoint}?id=${id}`);
  }

  public saveEducationForm(params: any) {
    return this.api.post(`${this.endpoint}`, {
      ...params
    });
  }

  public deleteEducationForm(id: number) {
    return this.api.delete(`${this.endpoint}?id=${id}`);
  }

  public getList() {
    return this.api.get<EducationForm[]>(`${this.endpoint}/list`);
  }
}
